module.exports = __webpack_public_path__ + "img/addToWalleCardtRe.30a01656.svg";